import Api, { getAccessToken } from "api";

export interface ResGetDomains {
	_id: string;
	domain: string;
	maxUsers: number;
	registerCountUsers: number;
	isActive: boolean;
}

export interface DataCreateDomain
{
	domain: string;
	maxUsers: number;
	isActive: boolean;
}

export interface ResUpdateStatusDomain {
	_id: string;
	isActive: boolean;
}

export class Domains
{
	async getDomains()
	{
		return (
			await Api.instance.get<ResGetDomains[]>(
				"/admin/getAllCorporateDomains",
				{
					headers:
					{
						"Content-Type": "application/x-www-form-urlencoded",
						Authorization: "Bearer " + getAccessToken()
					}
				}
			)
		).data;
	}
	async changeActive(id: string, isActive: boolean)
	{

		return (
			await Api.instance.put<ResGetDomains>(
				"/admin/updateDomain",
				{ id, isActive },
				{
					headers:
					{
						"Content-Type": "application/json",
						Authorization: "Bearer " + getAccessToken()
					}
				}
			)
		).data;
	}

	async createDomain(domain: string, maxUsers: number, isActive: boolean)
	{

		return (
			await Api.instance.post<ResGetDomains>(
				"/admin/createDomain",
				{ domain, maxUsers, isActive },
				{
					headers:
					{
						"Content-Type": "application/json",
						Authorization: "Bearer " + getAccessToken()
					}
				}
			)
		).data;
	}

	async deleteDomain(id: string)
	{
		return (
			await Api.instance.delete<ResGetDomains>(
				"/admin/deleteDomain/" + id,
				{
					headers:
					{
						"Content-Type": "application/json",
						Authorization: "Bearer " + getAccessToken()
					}
				}
			)
		).data;
	}
}
